<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['class_mgt'] == 1">
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="mb-2 float-end">
                <b-button v-b-modal.new-busary size="sm" variant="primary"
                  ><i class="mdi mdi-plus"></i> New Combination</b-button
                >
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select
                        class="form-select form-select-sm mx-1"
                        v-model="perPage"
                        size="sm"
                        :options="Options"
                      ></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                  <template #table-busy
                    ><div class="text-center text-primary my-2">
                      <b-spinner
                        class="align-middle"
                        type="grow"
                        small
                      ></b-spinner>
                      <strong>No Data Found</strong>
                    </div></template
                  >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(comb)="data">
                    <strong style="font-size: larger;">{{
                      data.item.comb
                    }}</strong>
                    <br /><small>{{ data.item.subsidiary2.name }}</small>
                  </template>
                  <template #cell(sub1)="data">
                    {{ data.item.sub1.name }}
                  </template>
                  <template #cell(sub2)="data">
                    {{ data.item.sub2.name }}
                  </template>
                  <template #cell(sub3)="data">
                    {{ data.item.sub3.name }}
                  </template>
                  <template #cell(subsidiary1)="data">
                    {{ data.item.subsidiary1.name }}
                  </template>

                  <template #cell(actions)="data">
                    <div class="btn-group">
                      <b-button
                        @click="remove(data.item.id, data.item.comb)"
                        type="button"
                        class="btn-sm btn"
                        variant="danger"
                        v-b-modal.delete
                      >
                        <i class="mdi mdi-trash-can"></i>
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="List"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="new-busary"
        centered
        title="New Subject Combination"
        title-class="font-18"
        hide-footer
        @hidden="resetForm"
      >
        <form @submit.prevent="addFeesCategory">
          <div class="form-group mb-1">
            <label>Subject 1 <small> (Main)</small></label>
            <multiselect
              v-model="sub1"
              label="name"
              :options="mainSubjects"
              track-by="id"
              @input="updateAvailableSubjects"
            ></multiselect>
          </div>
          <div class="form-group mb-2">
            <label>Subject 2 <small> (Main)</small></label>
            <multiselect
              v-model="sub2"
              label="name"
              :options="mainSubjects2"
              track-by="id"
              @input="updateAvailableSubjects"
            ></multiselect>
          </div>
          <div class="form-group mb-2">
            <label>Subject 3 <small> (Main)</small></label>
            <multiselect
              v-model="sub3"
              label="name"
              :options="mainSubjects3"
              track-by="id"
              @input="updateAvailableSubjects"
            ></multiselect>
          </div>
          <div class="form-group mb-2">
            <label>Subsidiary 1</label>
            <multiselect
              v-model="subsidiary1"
              label="name"
              :options="subsidiarySubjects"
              track-by="id"
              @input="validateSubsidiary1"
            ></multiselect>
            <small class="text-danger" v-if="subsidiary1Error">{{
              subsidiary1Error
            }}</small>
          </div>
          <div class="form-group mb-2">
            <label
              >Subsidiary 2 <small><b>(General Paper)</b></small></label
            >
            <multiselect
              v-model="subsidiary2"
              label="name"
              :options="gpSubjects"
              track-by="id"
              @input="validateSubsidiary2"
            ></multiselect>
            <small class="text-danger" v-if="subsidiary2Error">{{
              subsidiary2Error
            }}</small>
          </div>
          <div class="form-group mb-2">
            <label>Combination</label>
            <input class="form-control" type="text" v-model="comb" readonly />
          </div>

          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('new-busary')"
              >Close</b-button
            >
            <b-button
              type="submit"
              class="btn ms-1 w-30"
              variant="primary"
              :disabled="!isFormValid"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="delete-busary"
        centered
        title="Delete Subject Combination"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="removeFeesCategory">
          <input v-model="id" type="hidden" />
          Are you sure you want to delete the combination : <b>{{ comb }}</b> ?
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('delete-busary')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> YES</b-button
            >
          </div>
        </form>
      </b-modal>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  alevelsubjectsComputed,
  alevelsubjectsMethods,
  combinationsComputed,
  combinationsMethods,
} from "@/state/helpers";
import axios from "axios";
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Combinations",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      title: "Subject Combinations",
      items: [
        { text: "Dashboard", to: "/" },
        { text: " Subject Combinations", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "comb", label: "Combination", visible: true },
        { key: "sub1", label: "Subject 1", visible: true },
        { key: "sub2", label: "Subject 2", visible: true },
        { key: "sub3", label: "Subject 3", visible: true },
        { key: "subsidiary1", label: "Subsidiary", visible: true },
        { key: "actions", label: "Actions", visible: true },
      ],
      userData: JSON.parse(localStorage.getItem("user")),
      id: "",
      sub1: null,
      sub2: null,
      sub3: null,
      subsidiary1: null,
      subsidiary2: null,
      comb: "",
      subsidiary1Error: "",
      subsidiary2Error: "",
      mainSubjects: [],
      mainSubjects2: [],
      mainSubjects3: [],
      subsidiarySubjects: [],
      gpSubjects: [],
    };
  },
  computed: {
    ...combinationsComputed,
    ...alevelsubjectsComputed,
    List() {
      return this.combinations.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.combinations.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.combinations.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    isFormValid() {
      return (
        this.sub1 &&
        this.sub2 &&
        this.sub3 &&
        this.subsidiary1 &&
        this.subsidiary2 &&
        !this.subsidiary1Error &&
        !this.subsidiary2Error
      );
    },
  },
  watch: {
    alevelsubjects(newVal) {
      this.mainSubjects = newVal.filter((subject) => subject.stat == 1);
      this.mainSubjects2 = [...this.mainSubjects];
      this.mainSubjects3 = [...this.mainSubjects];

      this.subsidiarySubjects = newVal.filter((subject) => subject.stat == 2);
      this.gpSubjects = newVal.filter(
        (subject) =>
          subject.name.toLowerCase().includes("general paper") ||
          subject.name.toLowerCase().includes("gp"),
      );
    },
    sub1(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.updateAvailableSubjects();
        this.generateCombination();
      }
    },
    sub2(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.updateAvailableSubjects();
        this.generateCombination();
      }
    },
    sub3(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.updateAvailableSubjects();
        this.generateCombination();
      }
    },
    subsidiary1() {
      this.validateSubsidiary1();
      this.generateCombination();
    },
    subsidiary2() {
      this.validateSubsidiary2();
    },
  },
  mounted() {
    this.fetchCombinations();
    this.fetchAlevelSubjects();
    this.TotalRows = this.combinations.length;
    this.isBusy = false;
  },
  methods: {
    ...combinationsMethods,
    ...alevelsubjectsMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    remove(id, comb) {
      this.id = id;
      this.comb = comb;
      this.$bvModal.show("delete-busary");
    },
    updateAvailableSubjects() {
      const selectedIds = [];
      if (this.sub1) selectedIds.push(this.sub1.id);
      if (this.sub2) selectedIds.push(this.sub2.id);
      if (this.sub3) selectedIds.push(this.sub3.id);

      this.mainSubjects = this.alevelsubjects.filter(
        (subject) =>
          (subject.stat == 1 && !selectedIds.includes(subject.id)) ||
          (this.sub1 && subject.id === this.sub1.id),
      );

      this.mainSubjects2 = this.alevelsubjects.filter(
        (subject) =>
          (subject.stat == 1 && !selectedIds.includes(subject.id)) ||
          (this.sub2 && subject.id === this.sub2.id),
      );

      this.mainSubjects3 = this.alevelsubjects.filter(
        (subject) =>
          (subject.stat == 1 && !selectedIds.includes(subject.id)) ||
          (this.sub3 && subject.id === this.sub3.id),
      );
    },
    validateSubsidiary1() {
      if (!this.subsidiary1) {
        this.subsidiary1Error = "";
        return;
      }

      const name = this.subsidiary1.name.toLowerCase();

      if (
        name.includes("ict") ||
        name.includes("computer studies") ||
        name.includes("information technology") ||
        name.includes("ict")
      ) {
        this.subsidiary1Error = "";
      } else if (name.includes("math") || name.includes("maths")) {
        this.subsidiary1Error = "";
      } else {
        this.subsidiary1Error =
          "Subsidiary 1 must be ICT / Computer Studies or SubsidiaryMaths";
      }
    },
    validateSubsidiary2() {
      if (!this.subsidiary2) {
        this.subsidiary2Error = "";
        return;
      }

      const name = this.subsidiary2.name.toLowerCase();

      if (name.includes("general paper") || name.includes("gp")) {
        this.subsidiary2Error = "";
      } else {
        this.subsidiary2Error = "This field is only for General Paper";
      }
    },
    getSubjectInitials(subject) {
      if (!subject) return "";

      const name = subject.name.toLowerCase();

      if (name.includes("technical drawing")) return "TD";
      if (
        name.includes("food and nutrition") ||
        name.includes("food nutrition")
      )
        return "FN";

      if (name.includes(" ")) {
        return name
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase())
          .join("");
      }

      return subject.name.charAt(0).toUpperCase();
    },
    getSubsidiaryCode(subject) {
      if (!subject) return "";

      const name = subject.name.toLowerCase();

      if (
        name.includes("ict") ||
        name.includes("computer studies") ||
        name.includes("information technology")
      ) {
        return "ICT";
      } else if (name.includes("math") || name.includes("maths")) {
        return "SUBMATH";
      }

      return "";
    },
    generateCombination() {
      if (this.sub1 && this.sub2 && this.sub3 && this.subsidiary1) {
        const sub1Initial = this.getSubjectInitials(this.sub1);
        const sub2Initial = this.getSubjectInitials(this.sub2);
        const sub3Initial = this.getSubjectInitials(this.sub3);

        const subsidiaryCode = this.getSubsidiaryCode(this.subsidiary1);

        this.comb = `${sub1Initial}${sub2Initial}${sub3Initial}/${subsidiaryCode}`;
      } else {
        this.comb = "";
      }
    },
    resetForm() {
      this.sub1 = null;
      this.sub2 = null;
      this.sub3 = null;
      this.subsidiary1 = null;
      this.subsidiary2 = null;
      this.comb = "";
      this.subsidiary1Error = "";
      this.subsidiary2Error = "";
      this.updateAvailableSubjects();
    },
    async addFeesCategory() {
      if (!this.isFormValid) return;

      let formData = new FormData();
      formData.append("sub1", this.sub1.id);
      formData.append("sub2", this.sub2.id);
      formData.append("sub3", this.sub3.id);
      formData.append("subsidiary1", this.subsidiary1.id);
      formData.append("subsidiary2", this.subsidiary2.id);
      formData.append("comb", this.comb);
      let url = "/addsubjectcombination";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchCombinations();
          this.$bvModal.hide("new-busary");
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async removeFeesCategory() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/deletecombination";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchCombinations();
          this.$bvModal.hide("delete-busary");
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
  },
};
</script>
